import { EnumerationDto } from '@/api/backoffice/clients';

export const ENUM_StatusTypes = {
    Draft: createEnumValue(0, 'Draft'),
    Actief: createEnumValue(1, 'Actief'),
    NietActief: createEnumValue(2, 'Niet-actief'),
    Gearchiveerd: createEnumValue(3, 'Gearchiveerd')
};

export const ENUM_PublicationTypes = {
    Dataset: createEnumValue(0, 'Dataset'),
    Datasetserie: createEnumValue(1, 'Datasetserie')
};

export const ENUM_ProductStatusTypes = {
    InWachtrij: createEnumValue(1, 'In wachtrij'),
    Gefaald: createEnumValue(2, 'Gefaald'),
    Afgebroken: createEnumValue(3, 'Afgebroken'),
    Gestart: createEnumValue(4, 'Gestart'),
    Nabewerking: createEnumValue(5, 'Nabewerking'),
    PublicatieGepland: createEnumValue(6, 'Publicatie gepland'),
    DataGepubliceerd: createEnumValue(7, 'Data gepubliceerd'),
    MetadataGepubliceerd: createEnumValue(8, 'Metadata gepubliceerd'),
    Verwerkt: createEnumValue(100, 'Verwerkt')
};

export const ENUM_DeliveryStatusTypes = {
    InWachtrij: createEnumValue(1, 'In wachtrij'),
    Gefaald: createEnumValue(2, 'Gefaald'),
    Afgebroken: createEnumValue(3, 'Afgebroken'),
    BestandOntvangenEnUitgepakt: createEnumValue(4, 'Bestand ontvangen en uitgepakt'),
    Voorbewerking: createEnumValue(5, 'Voorbewerking'),
    Controle: createEnumValue(6, 'Controle'),
    Geweigerd: createEnumValue(7, 'Geweigerd'),
    Gevalideerd: createEnumValue(8, 'Gevalideerd'),
    EvaluatieControle: createEnumValue(9, 'Evaluatie controle'),
    GeweigerdDoorEvaluator: createEnumValue(10, 'Geweigerd door evaluator'),
    GoedgekeurdDoorEvaluator: createEnumValue(11, 'Goedgekeurd door evaluator'),
    Inladen: createEnumValue(12, 'Inladen'),
    Tussenbewerking: createEnumValue(13, 'Tussenbewerking'),
    HistoriekOpbouwen: createEnumValue(14, 'Historiek opbouwen'),
    EvaluatieWijzigingen: createEnumValue(15, 'Evaluatie wijzigingen'),
    GeweigerdDoorEvaluator2: createEnumValue(16, 'Geweigerd door evaluator'),
    GoedgekeurdDoorEvaluator2: createEnumValue(17, 'Goedgekeurd door evaluator'),
    Verwerkt: createEnumValue(100, 'Verwerkt')
};

function createEnumValue(id: number, name: string): EnumerationDto {
    return { id, name };
}
